// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    body * {
      visibility: hidden;
      font-family: 'Times New Roman', Times, serif;
    }
    .hideBtn{
        display: none;
    }
    #hideDate {
        display: none;
    }
    .hideCustomHeader{
      display: none;
    }
    .hideCustomInput{
      display: none;
    }
    .causeListHeading {
      page-break-after: always;
    }
    #customCauseListPrint{
      visibility: visible;
    }
    #customCauseListPrint,
    #customCauseListPrint * {
      visibility: visible;
    }

    #customCauseListPrint {
        position: absolute;
        left: 0;
        top: 0;
        zoom: 150%;
        font-size: 20px;
        page-break-inside: avoid;
      }

  }`, "",{"version":3,"sources":["webpack://./src/app/dashboard/causeList/printCustomCauseList.css"],"names":[],"mappings":"AAAA;IACI;MACE,kBAAkB;MAClB,4CAA4C;IAC9C;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;MACE,aAAa;IACf;IACA;MACE,aAAa;IACf;IACA;MACE,wBAAwB;IAC1B;IACA;MACE,mBAAmB;IACrB;IACA;;MAEE,mBAAmB;IACrB;;IAEA;QACI,kBAAkB;QAClB,OAAO;QACP,MAAM;QACN,UAAU;QACV,eAAe;QACf,wBAAwB;MAC1B;;EAEJ","sourcesContent":["@media print {\n    body * {\n      visibility: hidden;\n      font-family: 'Times New Roman', Times, serif;\n    }\n    .hideBtn{\n        display: none;\n    }\n    #hideDate {\n        display: none;\n    }\n    .hideCustomHeader{\n      display: none;\n    }\n    .hideCustomInput{\n      display: none;\n    }\n    .causeListHeading {\n      page-break-after: always;\n    }\n    #customCauseListPrint{\n      visibility: visible;\n    }\n    #customCauseListPrint,\n    #customCauseListPrint * {\n      visibility: visible;\n    }\n\n    #customCauseListPrint {\n        position: absolute;\n        left: 0;\n        top: 0;\n        zoom: 150%;\n        font-size: 20px;\n        page-break-inside: avoid;\n      }\n\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
